/**
 * Student Account
 * Student Account Api - Validation flow
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: dmartinez@ilernaonline.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The InlineResponse20012StartDateJoin model module.
 * @module model/InlineResponse20012StartDateJoin
 * @version 1.0.0
 */
class InlineResponse20012StartDateJoin {
    /**
     * Constructs a new <code>InlineResponse20012StartDateJoin</code>.
     * @alias module:model/InlineResponse20012StartDateJoin
     */
    constructor() { 
        
        InlineResponse20012StartDateJoin.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>InlineResponse20012StartDateJoin</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/InlineResponse20012StartDateJoin} obj Optional instance to populate.
     * @return {module:model/InlineResponse20012StartDateJoin} The populated <code>InlineResponse20012StartDateJoin</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new InlineResponse20012StartDateJoin();

            if (data.hasOwnProperty('date')) {
                obj['date'] = ApiClient.convertToType(data['date'], 'String');
            }
            if (data.hasOwnProperty('timezone_type')) {
                obj['timezone_type'] = ApiClient.convertToType(data['timezone_type'], 'Number');
            }
            if (data.hasOwnProperty('timezone')) {
                obj['timezone'] = ApiClient.convertToType(data['timezone'], 'String');
            }
        }
        return obj;
    }


}

/**
 * @member {String} date
 */
InlineResponse20012StartDateJoin.prototype['date'] = undefined;

/**
 * @member {Number} timezone_type
 */
InlineResponse20012StartDateJoin.prototype['timezone_type'] = undefined;

/**
 * @member {String} timezone
 */
InlineResponse20012StartDateJoin.prototype['timezone'] = undefined;






export default InlineResponse20012StartDateJoin;

